define('modules/wawi/product/controllers/tabs/StockManagementTabController',[], function () {
	'use strict';

	return ($parentScope, $scope, { BASE_TEMPLATES_PATH }) => {
		$parentScope.formTabs.push({
			label: 'FIELDS.STOCK_MANAGEMENT',
			template: BASE_TEMPLATES_PATH + '/wawi/product/stock-management.html',
		});
	};
});

